var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = require("static/personalCenter/myorder.png")

  var l0 = _vm.__map(_vm.list, function(t, i) {
    var m1 = _vm.$getImg(t.imageUrl)
    var m2 = _vm.maxName(t.bodyName + "-" + t.productName)
    var m3 = _vm.maxName(t.productName)
    var m4 = _vm.orderStatusName(t)
    return {
      $orig: _vm.__get_orig(t),
      m1: m1,
      m2: m2,
      m3: m3,
      m4: m4
    }
  })

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        l0: l0
      }
    }
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }